import type { KeyObject } from '@/features/shared/tools/KeyObjectStore'
import type { NavigateToDemande, NavigateToQuery } from '@/router/navigateTo'

export const LocationToFormationDemandeCAPP: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'capp',
} as const
export const LocationToFormationDemandeCPRO: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'cpro',
} as const
export const LocationToFormationDemandePROA: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'proa',
} as const
export const LocationToFormationDemandeAF: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'af',
} as const
export const LocationToFormationDemandeCXPI: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'fpe',
  sousDispositif: ['cdpi', 'cipi'],
} as const
export const LocationToFormationDemandeFPE_AF: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'fpe',
  sousDispositif: 'AfFpe',
} as const
export const LocationToFormationDemandeCAR: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'formations',
  module: 'demande',
  dispositif: 'fpe',
  sousDispositif: 'Car',
} as const
export const LocationToDrfDemandeCXPI: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'drf',
  module: 'demande',
  dispositif: 'fpe',
} as const
export const LocationToDrfDossierCXPI: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'drf',
  module: 'dossier',
  dispositif: 'fpe',
} as const
export const LocationToDemandeOutilFPE: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'tt',
  module: 'demande',
  dispositif: 'fpe',
} as const
export const LocationToDrDemande: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'dr',
  module: 'demande',
} as const
export const LocationToDrDossier: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'dr',
  module: 'dossier',
} as const
export const LocationToProformaDemande: KeyObject<NavigateToDemande> = {
  to: 'detail',
  domaine: 'dr',
  module: 'proforma',
} as const

// Recherches
export const LocationToRechercheFormationDossiers: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'formations',
  module: 'dossier',
}
export const LocationToRechercheFormationDemandes: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'formations',
  module: 'demande',
}
export const LocationToRechercheDrfDossiersCXPI: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'drf',
  module: 'dossier',
}
export const LocationToRechercheDrfDemandesCXPI: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'drf',
  module: 'demande',
}

export const LocationToRechercheFactures: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'factures',
}

export const LocationToRechercheVirements: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'virements',
}

export const LocationToRechercheDrDemandes: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'dr',
  module: 'demande',
}

export const LocationToRechercheDrDossiers: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'dr',
  module: 'dossier',
}

export const LocationToRechercheProformaDemandes: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'dr',
  module: 'proforma',
}

export const LocationToRechercheOutilFPEDemandes: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'tt',
  module: 'demande',
}

export const LocationToRechercheOutilFPEDossiers: KeyObject<NavigateToQuery> = {
  to: 'recherche',
  domaine: 'tt',
  module: 'dossier'
}
